// extracted by mini-css-extract-plugin
module.exports = {"notificationButton":"styles_notificationButton__r2NMC","unread":"styles_unread__1U08L","clientUnread":"styles_clientUnread__1Osh7","wrapper":"styles_wrapper__19PP_"};